IntlMessageFormat.__addLocaleData({"locale":"ks","pluralRuleFunction":function (n,ord){if(ord)return"other";return n==1?"one":"other"}});
IntlMessageFormat.__addLocaleData({"locale":"ks-Arab","parentLocale":"ks"});
IntlMessageFormat.__addLocaleData({"locale":"ks-Arab-IN","parentLocale":"ks-Arab"});
